import React, {useState, useContext, useEffect} from 'react';
import './Notifications.scss';
import {Loader} from '../_common';
import {NotificationsContext} from '../../contexts/notificationsContext';
import {setUTCDate} from '../../helpers/helpers';

const Notifications = () => {
  const { pending, notifications, getNotifications } = useContext(NotificationsContext);

  useEffect(() => {
    getNotifications();
  }, []);

  return (
    <div className='Notifications'>
      <div className='notificationList'>
        {!!pending && (
          <div className='loaderWrapper'><Loader /></div>
        )}

        {!pending && notifications.sort((a, b) => b.occurredAt.localeCompare(a.occurredAt)).map(item => (
          <div className='notificationItem' key={item?.id}>
            <div className='notificationItemHeader'>
              <div className='headerTitle'>
                {item.occurredAt
                  ? new Date(setUTCDate(item.occurredAt)).toLocaleDateString('pl-PL') +
                  ' ' +
                  new Date(setUTCDate(item.occurredAt)).toLocaleTimeString('pl-PL')
                  : ''
                }
              </div>
              {!item.read &&
                <div className='notificationUnreadIndicator'/>
              }
            </div>
            <div className='notificationItemText'>
              {item?.text}
            </div>
            {item?.name}
          </div>
        ))}
      </div>
    </div>
  )
};

export default Notifications;
